import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ISubNavCollection } from './sub.nav.horizonal.interface';

@Component({
    selector: 'mlp-ng-sub-nav-horizontal',
    templateUrl: './sub.nav.horizontal.component.html',
    styleUrls: ['./sub.nav.horizontal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class SubNavHorizontalSharedComponent {
    @Input() links: ISubNavCollection;
}
